import { NgModule, } from '@angular/core';
import { AuthProvider } from './auth/auth.provider';
import { FirestoreProvider } from './firestore/firestore.provider';
import { UsersFirestoreProvider } from './firestore/users-firestore.provider';
import { StorageProvider } from './storage/storage.provider';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
      AuthProvider,
      FirestoreProvider,
      UsersFirestoreProvider,
      StorageProvider
    ],
})
export class FirebaseModule { }